export default {
  primary: {
    main: '#FFFFFF',
    dark: '#B4AEBC',
  },
  error: {
    main: '#dc3545',
  },
  text: {
    primary: '#FFFFFF',
  },
  badge: {
    text: '#5F40E5',
    background: '#5F40E514',
  },
  gridLine: '#313131',
  borderColor: '#989BA0',
  inputBorderHover: '#3F4A60',
  button: {
    background: '#181818',
    text: '#FFFFFF',
  },
  background: {
    default: '#222326',
    paper: '#181818',
  },
  action: {
    hover: 'rgba(255, 255, 255, 0.1)',
  },
};
